import React from 'react';
import { ProjectTasksList } from './ProjectTasksList';
import { ProjectTasksSidebar } from './ProjectTasksSidebar';

export function ProjectTasksMain() {
  return (
    <div className="grid grid-cols-1 xl:grid-cols-12 gap-6 items-start">
      {/* Cột chính: Danh sách công việc */}
      <div className="xl:col-span-9 space-y-6">
        <ProjectTasksList />
      </div>

      {/* Cột phụ: Thống kê & Lịch */}
      <div className="xl:col-span-3 space-y-6">
        <ProjectTasksSidebar />
      </div>
    </div>
  );
}
